var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKz = function SvgKz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M18.783 12.13H5.218c0 .937.815 1.696 1.752 1.696h-.057c0 .936.76 1.695 1.696 1.695 0 .937.76 1.696 1.696 1.696h3.391c.937 0 1.696-.759 1.696-1.696.936 0 1.695-.759 1.695-1.695h-.056c.936 0 1.752-.76 1.752-1.696Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M16.696 9.914a4.696 4.696 0 0 1-9.391 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m15.586 9.912-1.465.69.78 1.42-1.591-.305-.202 1.607L12 12.142l-1.109 1.182-.201-1.607-1.592.304.78-1.42-1.465-.689 1.466-.689-.78-1.42 1.59.305.202-1.608L12 7.683 13.108 6.5l.202 1.608 1.591-.304-.78 1.42 1.465.688Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKz;